<template>
	<div class='barchart'>
		<h3 class='plot_title'>{{name}}</h3>
		<svg :id='id' width='480px' height='240px'></svg>
	</div>
</template>

<script>
export default {

	name : 'BarchartROV', 
	props : [
		'id',
		'name',
		'district'
	],
	mounted() {
		let component = this
		component.draw()
	},
	methods : {
		draw() {
			const name = this.name,
				id = this.id,
				height = 240,
				width = 480

			let dataset = require('/src/assets/final_df.json'),
				district = this.district.replace(' ', '_'),
				data = dataset[district]['number_family_component_distr'],
				margin = ({top: 20, right: 30, bottom: 36, left: 56})

			console.log(this.district)

			let svg = d3.select(`#${id}`)

			let x = d3.scaleBand()
				.domain(data.map(d => d))
				.range([margin.left, width - margin.right])
				.padding(0.1)

			let x_tick = d3.scaleBand()
				.domain(data.map((d, i) => i+1))
				.range([margin.left, width - margin.right])
				.padding(0.1)

			let y = d3.scaleLinear()
				.domain([0, d3.max(data, d => d)]).nice()
				//.domain([0, 2318]).nice()
				.range([height - margin.bottom, margin.top])

			let xAxis = g => g
				.attr('transform', `rotate(45)`)
				.attr('transform', `translate(0,${height - margin.bottom})`)
				.call(d3.axisBottom(x_tick)
					.tickSizeOuter(0))

			let yAxis = g => g
				.attr('transform', `translate(${margin.left}, 0)`)
				.call(d3.axisLeft(y)
					.ticks(10)
					.tickSizeOuter(0)
					.tickSize(-(width-margin.left-margin.right))
					)

			// Add X axis label:
			svg.append("text")
			    .attr("text-anchor", "start")
			    .attr("x", margin.left)
				.attr("y", height - 8)
				.attr('style', 'font-size : 11px;')
			    .text("numero di componenti per famiglia")

			// Y axis label:
			svg.append("text")
			    .attr("text-anchor", "start")
			    .attr("y", -12)
				.attr("x", margin.top - 4)
			    .attr("transform", "rotate(90)")
			    .attr('style', 'font-size : 11px;')
			    .text("numero di famiglie")


			svg.append('g')
				.attr('class', 'x_axis')
				.call(xAxis)
			
			svg.append('g')
			.attr('class', 'y_axis')
				.call(yAxis)
				.call(g => g.select('.domain').remove())
				

			svg.append('g')
					.attr('fill', '#0D256E')
				.selectAll('rect').data(data).enter()
				.append('rect')
					.attr('x', (d, i) => x(d))
					.attr('y', d => y(d))
					.attr('height', d => y(0) - y(d))
					.attr('width', x.bandwidth())
					.on('mouseover', function(d,i){
					$(this).attr('fill', '#12349C')
					$(this).attr('cursor', 'pointer')
					})
					.on('mouseout', function(d,i){
					$(this).attr('fill', '#0D256E')
					// $(this).attr('cursor', 'auto')
					$('#tooltip').css('opacity', 0)
					})
			
			svg.append('g')
				.selectAll('text').data(data).enter()
				.append('text')
					.text(d => d)
					.attr('x', (d, i) => (x(d) + (x.bandwidth()/2)))
						.attr('y', d => y(d) - 4) 
						.attr('style', 'font-size: 10px; text-anchor: middle;')


			d3.selectAll('.tick>text')
				.each(function(d, i){
				d3.select(this).style('font-size','10px')
			})

			d3.selectAll('.y_axis>.tick>line')
				.each(function(d, i){
				d3.select(this)
					.style('opacity','.12')
			})
		
		}
	}
}
</script>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
	.barchart {
/*		position: absolute;*/
		background-color: #FFF;
/*		top: 85px;*/
/*		z-index: 2;*/
		text-align: left;
	}

	.bar_legend {
		width: calc(100% - 20px);
		text-align: left;
		margin-left: 20px;
		display: flex;
	}
	.legend_pars {
		margin-left: 4px;
	}
	.legend_pars p {;
		font-size: 12.5px;
		width: calc(400px - 64px);
	}

</style>